import { useQueryClient } from "@tanstack/react-query";
import { ConfirmationModal, toastMessage } from "components/common/helpers";
import { FC } from "react";
import { useParams } from "react-router-dom";
import { PublishAnalysis } from "routes/administration/queries/analysis";
import { AnalysisData } from "routes/analysis/types/analysis";

interface PublishFormProps {
  analysis: AnalysisData | undefined;
  close: () => void;
}

const PublishForm: FC<PublishFormProps> = ({ analysis, close }) => {
  const { clientId } = useParams();
  const queryClient = useQueryClient();
  const { mutate: publishAnalysis } = PublishAnalysis(analysis);

  const handleSubmit = async () => {
    if (!analysis) return;
    await publishAnalysis(analysis, {
      onError: () => {
        toastMessage("Publishing failed", null, "error");
      },
      onSuccess: () => {
        toastMessage("Analysis published");
        queryClient.invalidateQueries({ queryKey: ["analyses", clientId] });
        close();
      }
    });
  }
  
  return (
    <ConfirmationModal
      visible={analysis !== undefined}
      title="Publish analysis"
      cancel={() => close()}
      confirm={() => handleSubmit()}
    >
      <p>Are you sure you want to publish this analysis?</p>
      <p>Once published, the analysis will be available for the client to view.</p>
    </ConfirmationModal>
  )
}

export default PublishForm;
